/* prettier-ignore */
/* eslint-disable import/no-anonymous-default-export */

export default {
  common: {
    breadcrumb: {
      'chain-locations': 'Chain Locations',
      'touchpoint-behavior': 'Touchpoint Behavior',
      'touchpoint-devices': 'Touchpoint Devices',
      'account-profiles': 'Account Profiles',
      add: 'Add {{title}}',
      addNew: 'Add New {{title}}',
      'alert-template-setup': 'Alert Template Setup',
      alerts: 'Alerts',
      'age-restricted-policies': 'Age Restrictions',
      application: 'Application',
      'business-day': 'Business Day',
      'business-day-scheduler': 'Business Day Scheduler',
      'business-periods': 'Business Periods',
      'business-rules': 'Business Rules',
      'business-units': 'Business Unit',
      catalina: 'Catalina',
      'command-menu': 'Command Menu',
      culture: 'Culture',
      'culture-settings': 'Culture Settings',
      currencies: 'Currency',
      'currency-exchange-rate': 'Currency Exchange Rate',
      'data-pattern': 'Data Pattern',
      'device-types': 'Device Types',
      devices: 'Devices',
      'dms-servers': 'DMS Servers',
      'display-configurations': 'Display Configurations',
      general: 'General',
      integration: 'Integration',
      items: 'Items',
      'keyboard-programming': 'Keyboard Programming',
      'manual-approvals': 'Manual Approvals',
      menus: 'Menus',
      messages: 'Messages',
      'online-purchase-profile': 'Online Purchase Profile',
      'opening-funds': 'Opening Funds',
      'pharmacy-policy': 'Pharmacy Policy',
      plu: 'PLU',
      'plu-menus': 'PLU Menus',
      'plu-groups': 'PLU Groups',
      'policies-rules': 'Policies Rules',
      'reason-codes': 'Reason Codes',
      'return-policies': 'Return Policies',
      store: 'Store',
      stores: 'Stores',
      'store-setup': 'Store Setup',
      tabs: 'Tabs',
      tax: 'Tax',
      'tax-rates': 'Tax Rates',
      'tax-authorities': 'Tax Authorities',
      'tax-brackets': 'Tax Brackets',
      'tax-parameters': 'Tax Parameters',
      'tax-zones': 'Tax Zones',
      technical: 'Technical',
      'tender-exchange': 'Tender Exchange',
      'tender-fee-policy': 'Tender Fee Policy',
      'tender-item-restrictions': 'Tender Item Restrictions',
      'tender-services': 'Tender Services',
      'tender-menu': 'Tender Menu',
      tenders: 'Tenders',
      'touchpoint-applications': 'Touchpoint Applications',
      'touchpoint-branding': 'Touchpoint Branding',
      'touchpoint-categories': 'Touchpoint Categories',
      'touchpoint-groups': 'Touchpoint Groups',
      touchpointGroups: 'Touchpoint Groups',
      touchpoints: 'Touchpoints',
      'us-wic-tendering': 'US WIC Tendering',
      'wic-bet-policy': 'WIC EBT Policy',
      'wic-cvb-mapping': 'WIC CVB Product Mapping',
      'wic-product-exclusions': 'WIC Product Exclusions',
      organization: {
        'chain-locations': {
          touchpoints: {
            add: 'New Touchpoint',
          },
        },
        'touchpoint-devices': {
          'device-types': {
            add: 'New Device Type',
          },
          devices: {
            add: 'New Device',
          },
        },
        'business-day': {
          'business-day-scheduler': {
            add: 'Add new Business Day Scheduler',
          },
        },
      },
      operations: {
        stores: {
          touchpoints: {
            add: 'New Touchpoint',
          },
        },
        touchpoints: {
          'device-types': {
            add: 'New Device Type',
          },
          devices: {
            add: 'New Device',
          },
        },
      },
      sales: {
        'touchpoint-behavior': {
          'tender-menu': {
            add: 'New Tender Menu',
          },
          'touchpoint-branding': {
            add: 'New Touchpoint Branding',
          },
          'command-menu': {
            add: 'New Command Menu',
          },
        },
        barcodes: {
          'data-pattern': {
            add: 'New Data Pattern',
          },
        },
        items: {
          'online-purchase-profile': {
            add: 'New Online Purchase Profile',
          },
          'plu-groups': {
            add: 'New PLU Group',
          },
          'plu-menus': {
            add: 'New PLU Menu',
          },
        },
        return: {
          'return-policies': {
            add: 'new return policy',
          },
        },
        rules: {
          'age-restriction': 'Age Restrictions',
          titleRequired: {
            'age-restriction': {
              add: 'New Age Restricted Policy',
            },
          },
          'business-rules': {
            add: 'New Business Rule',
          },
        },
        tendering: {
          tender: {
            add: 'New Tender',
          },
          'tender-item-restrictions': {
            add: 'New Tender Item Restriction',
          },
          'tender-exchange': {
            add: 'New Tender Exchange',
          },
        },
        tax: {
          'tax-brackets': {
            add: 'New Tax Bracket',
          },
          'tax-parameters': 'Tax Exemption Parameters',
          'tax-rates': {
            add: 'New Tax Rate',
          },
        },
        touchpoints: {
          'tender-menu': {
            add: 'New Tender Menu',
          },
          'commands-menu': 'Commands Menu'
        },
        'us-wic-tendering': {
          'wic-ebt-agencies': 'WIC EBT Agencies',
          titleRequired: {
            'wic-ebt-agencies': {
              add: 'Add WIC Agency',
            },
          },
        },
      },
    },
    button: {
      add: 'Add',
      addAttribute: '+ Add Attribute',
      addCurrency: 'Add Currency',
      addDenomination: 'Add Denomination',
      addError: 'Add Error',
      addImage: 'Add Image',
      addNew: 'Add New',
      addNewCheckDigit: 'Add New Check Digit',
      addNewPLUGroup: 'Add New PLU Group',
      addNewPLUMenu: 'Add New PLU Menu',
      addNewPrefix: 'Add New Prefix',
      addNewTaxAuth: 'Add Tax Authority',
      addNewTaxBracket: 'Add Tax Bracket',
      addNewTaxParameters: 'Add New Tax Parameters',
      addNewTaxRate: 'Add New Tax Rate',
      addNewTender: 'Add Tender',
      addNewTenderMenu: 'Add Tender Menu',
      addNewTouchpoint: 'Add Touchpoint',
      addProducts: 'Add Products',
      applyToAll: 'Apply To All',
      back: 'Back',
      cancel: 'Cancel',
      cancelTitle: 'Discard changes',
      clear: 'Clear',
      delete: 'Delete',
      duplicateBusinessDay: 'Update Schedule',
      editActiveTheme: 'Edit Active Config',
      filter: 'Filter',
      finish: 'Finish',
      next: 'Next',
      no: 'No',
      ok: 'Ok',
      redo: 'Redo',
      removeAll: 'Remove All',
      save: 'Save',
      saveTitle: 'Save changes',
      search: 'Search',
      selectLocations: 'Select Locations',
      submit: 'Submit',
      undo: 'Undo',
      yes: 'Yes',
    },
    columnTitle: {
      active: 'Active',
      additionalCodes: 'Additional Codes',
      city: 'City',
      code: 'Code',
      customerExemptionId: 'Customer Exemption ID Required',
      customerExemptionName: 'Customer Exemption Name Required',
      description: 'Description',
      edit: 'Edit',
      endDate: 'End Date',
      id: 'ID',
      image: 'Image',
      language: 'Language',
      lastModified: 'Last Modified',
      location: 'Location',
      locations: 'Locations',
      merchandize: 'Merchandize Hierarchy',
      messageName: 'Name',
      messageType: 'Type',
      method: 'Method',
      name: 'Name',
      parent: 'Parent',
      phone: 'Phone',
      product: 'Product',
      rate: 'Rate',
      rateId: 'Rate ID',
      startDate: 'Start Date',
      status: 'Status',
      storeId: 'Store ID',
      storeName: 'Store Name',
      street: 'Street',
      taxZone: 'Tax Zone',
      tenderExchange: 'Tender Exchange',
      tenderCode: 'Tender Code',
      tenderName: 'Tender Name',
      tenderType: 'Tender Type',
      touchpointApplication: 'Touchpoint Application',
      touchpointApplications: 'Touchpoint Applications',
      touchpointGroup: 'Touchpoint Group',
      touchpointType: 'Touchpoint Type',
      type: 'Type',
      zoneName: 'Zone Name',
      value: 'Value',
      menu: 'Menu',
      menuType: 'Menu Type',
    },
    error: {
      alertSeverityNotFound: 'Alert Severity {{value}} not found',
      duplicateTender: 'Duplicate Tender',
      errorFromServer: 'Error from server',
      errorLoadingData: 'Error loading data for this component',
      languageRequired: 'Language is a required field',
      organization: 'Organization is required.',
      peakFord: 'Password is required.',
      roleIdNotFound: 'Role ID {{value}} not found',
      somethingWentWrong: 'Something went wrong...',
      touchpointGroupIdNotFound: 'Touchpoint Group ID {{value}} not found',
      touchpointTypeNotFound: 'Touchpoint Type {{value}} not found',
      translationRequired: 'Translation must contains at least one row',
      username: 'User Name is required.',
      valueDoesNotExist: 'Value does not exist',
      valueRequired: 'Value is a required field',
      productNotFound: 'The product you selected may be uncataloged',
      requiredTouchpointGroup: 'Touchpoint Groups is a required field',
      requiredTenders: 'Tenders is a required field',
      requiredProductsOrCategoryOrGroups: 'Products / Categories / Groups is a required field',
      requiredTender: 'Tender is a required field',
      requiredField: 'Required Field',
      tenderDoesNotExist: 'Tender does not exist',
      samePriorityShouldBeUsedForSameTenders: 'Same priority should be used for same tenders',
      differentAmountShouldBeUsed: 'Different amount should be used',
      refundTenderCannotBeDefineTwice: 'Refund tender cannot be define twice',
      differentPaidTenderCannotHaveSamePriority: 'Different paid tender cannot have same priority.',
      cultureNotExists: "Translation value doesn't exist",
      notFoundCategoryError: 'The hierarchy you selected may be uncataloged.',
      notFoundGroupError: 'The group you selected may be uncataloged.',
      locationAlreadyUsed: 'This location is already used',
      catalogServiceUnavailable: 'Catalog Service is unavailable',
      categoryNotFound: 'The category you selected may be uncataloged',
      groupNotFound: 'The group you selected may be uncataloged'
    },
    helperText: {
      exampleValueBasha: 'Example Value: Basha`s',
    },
    label: {
      allowedRolesToSwitch: 'Allowed Roles to Switch',
      chainLocations: 'Chain Locations',
      touchpointBehavior: 'Touchpoint Behavior',
      touchpointDevices: 'Touchpoint Devices',
      accountProfiles: 'Account Profiles',
      accountType: 'Account Type',
      acknowledgements: 'Acknowledgments',
      action: 'Action',
      actionType: 'Action Type',
      active: 'Active',
      addLogo: 'Add Your Logo',
      ageRestrictions: 'Age Restrictions',
      alertTemplate: 'Alert Template',
      alertTemplateId: 'Alert Template Id',
      alertTemplateSetup: 'Alert Template Setup',
      alerts: 'Alerts',
      algorithm: 'Algorithm',
      allowDuplicate: 'Allow Duplicate',
      allowSellableMedia: 'Allow Sellable Media',
      amount: 'Amount',
      application: 'Application',
      applyToAll: 'Apply to All',
      askCashier: 'Ask Cashier',
      authorizationUpon: 'Authorization Upon',
      bankAccountNumber: 'Bank Account Number',
      branding: 'Branding',
      barcode: 'Barcodes',
      beginDate: 'Begin Date',
      beginTime: 'Begin Time',
      businessDay: 'Business Day',
      businessDayScheduler: 'Business Day Scheduler',
      businessPeriods: 'Business Periods',
      businessRule: 'Business Rule',
      businessRules: 'Business Rules',
      businessUnits: 'Business Units',
      cancel: 'Cancel',
      card: 'Card',
      cashout: 'Cashout',
      cashOffice: 'Cash Office',
      catalina: 'Catalina',
      catalinaVersionNumber: 'Catalina Version Number',
      categories: 'Categories',
      category: 'Category',
      checkDigit: 'Check Digit',
      chipSelection: 'Selection',
      chipSelections: 'Selections',
      city: 'City',
      closingMethod: 'Closing Method',
      color: 'Color',
      colors: 'Colors',
      command: 'Command',
      commandMenu: 'Command Menu',
      commandName: 'Command Name',
      componentItemCode: 'Compensation Item Code',
      componentItemQuantity: 'Compensation Item Quantity',
      conditions: 'Conditions',
      configurationName: 'Configuration Name',
      conformationRequestRequired: 'Confirmation Request Required',
      contactPerson: 'Contact Person',
      content: 'Content',
      copy: 'Copy',
      country: 'Country',
      culture: 'Culture',
      cultureCode: 'Culture Code',
      cultureSettings: 'Culture Settings',
      currencies: 'Currency',
      currencyDecimalSeparator: 'Currency Decimal Separator',
      currencyExchangeRates: 'Currency Exchange Rate',
      currencyGroupSeparator: 'Currency Group Separator',
      currencyPositivePattern: 'Currency Positive Pattern',
      currencyNegativePattern: 'Currency Negative Pattern',
      currentExceptions: 'Current Exceptions',
      currentLogo: 'Current Logo',
      dataPatterns: 'Data Pattern',
      date: 'Date',
      dateRange: 'Date Range',
      days: 'Days',
      daysOfTheWeek: 'Days of the Week',
      decline: 'Decline',
      decodingPrefixRanges: 'Decoding Prefix Ranges ({{count}})',
      default: 'Default',
      delete: 'Delete',
      delayIntervention: 'Delay Intervention',
      description: 'Description',
      deviceTypes: 'Device Types',
      devices: 'Devices',
      displayConfigurations: 'Display Configurations',
      displayPreview: 'Display Preview',
      dmsServers: 'DMS Servers',
      edit: 'Edit',
      enableCatalinaFunctionality: 'Enable Catalina Functionality',
      encodingPrefixRanges: 'Encoding Prefix Ranges ({{count}})',
      endDate: 'End Date',
      endTime: 'End Time',
      enterNumber: 'Enter Number',
      enterUsername: 'Enter your Username',
      errors: 'Errors',
      event: 'Event',
      exactMatch: 'Exact Match',
      excludedSelections: 'Excluded Selections',
      excludedLocations: 'Excluded Locations',
      excludes: 'Excludes',
      exclusions: 'Exclusions',
      external: 'External',
      externalUniqueIdentifier: 'External Unique Identifier',
      fax: 'Fax',
      feeAmount: 'Fee Amount',
      feeId: 'Fee ID',
      fixed: 'Fixed',
      from: 'From',
      general: 'General',
      group: 'Group',
      groupId: 'Group Id',
      groups: 'Groups', // PolicyMembers.tsx
      id: 'ID',
      inBarcode: 'InBarcode',
      includeRxNumbers: 'Include Rx numbers in messages',
      includedGroups: 'Included Groups',
      includedLocations: 'Included Locations',
      includedSelections: 'Included Selections',
      inputLabel: 'Input Label',
      inputName: 'Input Name',
      inputType: 'Input Type',
      integration: 'Integration',
      ipAddress: 'IP Address',
      item: 'Item',
      itemCode: 'Item Code',
      itemQuantity: 'Item Quantity',
      itemSale: 'ItemSale',
      items: 'Items',
      keyboardProgramming: 'Keyboard Programming',
      keyCode: 'Key Code',
      language: 'Language',
      layout: 'Layout',
      length: 'Length',
      limitValueAmount: 'Limit Value Amount',
      limitValueType: 'Limit Value Type',
      localCurrency: 'Local Currency',
      location: 'Location',
      locationPh: 'Select a Location',
      locationSelection: 'Location Selection',
      locations: 'Locations',
      logicalName: 'Logical Name',
      logo: 'Logo',
      manualApprovals: 'Manual Approvals',
      maxAmount: 'Maximum Amount',
      maxPeriod: 'Max. Period',
      maximumAmount: 'Maximum Amount',
      menus: 'Menus',
      message: 'Message',
      messageName: 'Name',
      messageType: 'Type',
      messages: 'Messages',
      method: 'Method',
      minAmount: 'Minimum Amount',
      minMax: 'Min./Max.',
      minimumAmount: 'Minimum Amount',
      mismatchPolicy: 'Mismatch Policy',
      mod: 'MOD',
      modifier: 'Modifier',
      months: 'Months',
      multipleOf: 'Multiples Of',
      name: 'Name',
      nextDay: 'Next Day',
      number: 'Number',
      operations: 'Operations',
      organization: 'Organization',
      off: 'Off',
      offlineBehaviour: 'Offline Behaviour',
      offlineSalePriceSource: 'Offline Sale Price Source',
      ok: 'OK',
      on: 'On',
      offlineAuthorization: 'Offline Authorization',
      offset: 'Offset',
      onlineAuthorization: 'Online Authorization',
      onlinePurchaseProfile: 'Online Purchase Profile',
      openingFunds: 'Opening Funds',
      optional: 'Optional',
      panPadMessage: 'Pin pad messages',
      parameter: 'Parameter',
      parent: 'Parent',
      peakFord: 'Password',
      payWithTenders: 'Pay with Tenders',
      periodType: 'Period Type',
      pharmacyPolicy: 'Pharmacy Policy',
      pharmacyPrice: 'Pharmacy Price',
      phone: 'Phone',
      pinPadMessages: 'Pin pad messages',
      pinPadMessagesWithClientName: 'Pin pad messages includes patient name',
      plu: 'PLU',
      pluGroups: 'PLU Groups',
      pluMenus: 'PLU Menus',
      policiesAndRules: 'Policies and Rules',
      policyId: 'Policy ID', //RestrictedPolicy.tsx
      policyName: 'Policy Name',
      port: 'Port',
      position: 'Position',
      poweredBy: 'Powered by',
      predefinedAmount: 'Predefined Amount',
      prefix: 'Prefix',
      prefixLength: 'Prefix Length',
      prepayAccount: 'Prepay Account',
      preview: 'Preview',
      previousExceptions: 'Previous Exceptions',
      priceOverRide: 'Maximum Discount Amount',
      primaryColor: 'Primary Color',
      priority: 'Priority',
      productCategory: 'Products & Categories', // PolicyMembers.tsx
      product: 'Product',
      products: 'Products',
      protocolOriginator: 'Protocol Originator',
      protocolRevision: 'Protocol Revision',
      provider: 'Provider',
      providerMessage: 'Provider Message',
      quantity: 'Quantity',
      rate: 'Rate',
      rateId: 'Rate ID',
      reasonCodes: 'Reason Codes',
      reasonId: 'Reason Id',
      refundTenders: 'Refund Tenders',
      refundRequestRequired: 'Refund Request Required',
      regularExpression: 'Regular Expression',
      reoccurringDate: 'Reoccurring Date',
      requestingService: 'Requesting Service',
      requiresAttendant: 'Requires Attendant',
      requiresBalancing: 'Requires Balancing',
      return: 'Return',
      relation: 'Relation',
      repeatingPatternStart: 'Repeating pattern start',
      returnPolicies: 'Return Policies',
      role: 'Role',
      roles: 'Roles',
      ruleName: 'Name',
      rules: 'Rules',
      sampleText: 'Sample Text',
      save: 'Save',
      sales: 'Sales',
      scope: 'Scope',
      secondBarcode: 'SecondBarcode',
      secondaryColor: 'Secondary Color',
      selectType: 'Select Type',
      selections: 'Selections',
      severity: 'Severity',
      shortDateFormat: 'Short Date Format',
      shortTimeFormat: 'Short Time Format',
      signIn: 'Sign in',
      signatureRequired: 'Signature required',
      startDate: 'Start Date',
      startTime: 'Start Time',
      state: 'State',
      status: 'Status',
      store: 'Store',
      storeId: 'Store ID',
      storeHierarchy: 'Store Hierarchy',
      storeName: 'Store Name',
      storeNamePlaceholder: 'Enter Store Name',
      storeSetup: 'Store Setup',
      storeStatus: 'Status',
      storeStatusPlaceholder: 'Enter a status',
      stores: 'Stores',
      street: 'Street',
      tabs: 'Tabs',
      tax: 'Tax',
      taxAuthorities: 'Tax Authorities',
      taxBrackets: 'Tax Brackets',
      taxParameters: 'Tax Exemption Parameters',
      taxZones: 'Tax Zones',
      taxRates: 'Tax Rates',
      technical: 'Technical',
      temperature: 'Temperature',
      tender: 'Tender',
      tenderExchange: 'Tender Exchange',
      tenderFeePolicy: 'Tender Fee Policy',
      tendering: 'Tendering',
      tenderItemRestriction: 'Tender Item Restrictions',
      tenderMenu: 'Tender Menu',
      tenderServices: 'Tender Services',
      tenders: 'Tenders',
      text: 'Text',
      timeZone: 'Time Zone',
      timeoutDuration: 'Timeout Duration',
      to: 'To',
      total: 'Total',
      touchpointApplication: 'Touchpoint Application',
      touchpointApplications: 'Touchpoint Applications',
      touchpointApplicationsPh: 'Select a Touchpoint Applications',
      touchpointBranding: 'Touchpoint Branding',
      touchpointCategories: 'Touchpoint Categories',
      touchpointGroup: 'Touchpoint Group',
      touchpointGroupPh: 'Select a Touchpoint Group',
      touchpointGroupType: 'Touchpoint Group Type', //RestrictedPolicy.tsx
      touchpointGroups: 'Touchpoint Groups',
      touchpointId: 'Touchpoint ID',
      touchpointIdPh: 'Enter Touchpoint ID',
      touchpointType: 'Touchpoint Type',
      touchpointTypePh: 'Select a Touchpoint Type',
      touchpoints: 'Touchpoints',
      transactionComplete: 'TransactionComplete',
      transactionType: 'Transaction Type',
      translation: 'Translation',
      translations: 'Translations',
      triggeringEvent: 'Triggering Event',
      type: 'Type',
      upToAmount: 'Up to Amount',
      username: 'Username',
      usWicTendering: 'US WIC Tendering',
      value: 'Value',
      voidRequestRequired: 'Void Request Required',
      volumePricePrecision: 'Volume Price Precision',
      volumeUOM: 'Volume UOM',
      volumeUOMPrecision: 'Volume UOM Precision',
      weakSearch: 'Weak Search Criteria',
      wicBetPolicy: 'WIC EBT Policy',
      wicCVBMappings: 'WIC CVB Product Mapping',
      wicEbtAgencies: 'WIC EBT Agencies',
      wicProductExclusions: 'WIC Product Exclusions',
      weCouldNot: "We couldn't find anything matching",
      yes: 'Yes',
      zipCode: 'Zip Code',
    },
    menu: {},
    notifications: {
      saved: 'Saved!',
    },
    link: {},
    message: {
      allowDisallowRule: `This option enables you to define a rule to either prevent or allow customer orders to exceed a defined amount or quantity.`,
      allTouchpointGroups: 'All Touchpoint Groups',
      brandingDescription:
        'Manage configuration related to UI configuration, layout, and company branding.',
      cashOfficeDescription:
        'Manage configuration related to cash maintenance activities performed at the store including opening funds, account profiles and more',
      categoriesSelected: '{{count}} categories selected',
      chooseLocationsToApplyTo:
        'What stores should this design configuration be applied to? \nMore location-specific configs take precedence over general ones.',
      colorSelectionInstructions: 'Update the colors of the POS system.',
      displayConfigurationComplete: 'Your configuration is complete and ready to save!',
      duplicateBusinessDay: 'A schedule with this location already exists.',
      editActiveThemeConfirmation:
        'Changes saved to an active configuration are applied immediately and affect the POS display the next time users sign in.',
      fileUploadInstructions: 'Drag and Drop or Browse to Replace...',
      jarvisSelfCheckoutDescription: 'Manage configuration related to Self-Checkout',
      logoUploadInstructions:
        'Upload your logo below. The maximum size is 130 X 50 pixels. Images will be proportionally scaled to fit these dimensions. You can preview your logo after it is uploaded.',
      maxFileSize: 'Max file size: {{maxSize}}',
      operationsDescription:
        'Manage configuration related to store operational activities including touch point definitions, alerts & notifications, integration definitions and more',
      organizationDescription:
        'Manage configuration related to the retailer core definitions including culture definitions, touch point categorization and more',
      pleaseSelectHierarchy: 'Please select a hierarchy',
      primaryColorInstructions:
        'Used for primary action on the screen (Ex: frequently used buttons)',
      recommendedImageFileFormats: 'Recommended file formats: .svg, .png, .gif',
      resetOnHierarchyChange:
        'Changing a hierarchy selection will delete all selections made under that hierarchy',
      resultsPresented: '{{count}} result presented',
      resultsPresented_plural: '{{count}} results presented',
      salesDescription:
        'Manage configuration related to POS selling activities including tenders, tax, receipt definitions, return policies and more',
      secondaryColorInstructions: 'Used for icons and states',
      selectATenderType: 'Please select a Tender Type to continue',
      selectCategories: 'Please select a categories',
      selectCategory: 'Please select a category',
      selectHierarchy: 'Select a Hierarchy',
      serviceUnavailable: 'The server is temporarily unavailable.',
      somethingWentWrong: 'Something went wrong',
      tableNoOptions:
        "Please enter product code or description or select a category and click 'Search'",
      utilitiesDescription:
        'Manage utilities related to configuration such as import, export and more',
      weakSearchMessage:
        'Displaying only first 300 items out of {{searchTotalCount}} matching items. Please refine your search criteria.',
      withoutSaving: 'Are you sure you want to exit without saving?',
      youCanTryAgain: 'You can try again',
    },
    placeholder: {
      dateRange: 'Select a Date Range',
      enterAmount: 'Enter Amount',
      enterBankAccount: 'Enter Bank Account Number',
      enterBarcode: 'Enter Barcode',
      enterCity: 'Enter City',
      enterContactPerson: 'Enter Contact Person',
      enterCountry: 'Enter Country',
      enterDecimals: 'Enter Decimals',
      enterDescription: 'Enter Description',
      'enterError Code': 'Enter Error Code',
      enterFaxNumber: 'Enter Fax number',
      enterFixedValue: 'Enter Fixed Value',
      enterFrom: 'Enter From',
      enterGroupId: 'Enter Group Id',
      enterId: 'Enter ID',
      enterInputLabel: 'Enter Input Label',
      enterInputName: 'Enter Input Name',
      enterKey: 'Enter Key',
      enterLength: 'Enter Length',
      enterMaxAmount: 'Enter Maximal Amount',
      enterMaxPeriod: 'Enter Max. Period',
      enterMinAmount: 'Enter Minimal Amount',
      enterMinimumAmount: 'Enter Minimum Amount',
      enterMOD: 'Enter MOD',
      enterMultipleOf: 'Enter Multiple Of',
      enterName: 'Enter Name',
      enterNewIndicator: 'Enter New Indicator',
      enterNumber: 'Enter Number',
      enterOffset: 'Enter Offset',
      enterParent: 'Enter Parent',
      enterPhoneNumber: 'Enter Phone number',
      enterPolicyId: 'Enter Policy Id',
      enterPosition: 'Enter Position',
      enterPostalCode: 'Enter Zip code',
      enterPrefix: 'Enter Prefix',
      enterPriority: 'Enter Priority',
      enterQuantity: 'Enter Quantity',
      enterRate: 'Enter Rate',
      enterRateId: 'Enter Rate ID',
      enterReasonId: 'Enter Reason ID',
      enterRegularExpression: 'Enter Regular Expression',
      enterRepeatingPatternStart: 'Enter Repeating Pattern',
      'enterRequesting Service': 'Enter Requesting Service',
      enterState: 'Enter State',
      enterStoreId: 'Enter Store ID',
      enterStoreName: 'Enter Store Name',
      enterStreet: 'Enter Street',
      enterSuffix: 'Enter Suffix',
      enterTaxAuthorityId: 'Enter Authority ID',
      enterTaxTableId: 'Enter Tax Table ID',
      enterTenderCode: 'Enter Tender Code',
      enterTimeZone: 'Enter Time Zone',
      enterTo: 'Enter To',
      enterTouchpointGroupId: 'Enter Touchpoint Group ID',
      enterTouchpointGroupName: 'Enter Touchpoint Group Name',
      enterUsername: 'Enter your Username',
      enterValue: 'Enter Value',
      enterZipCode: 'Enter Zip Code',
      enterAValue: 'Enter a Value',
      hasNoContent: 'has no content to configure',
      message: 'Select Message',
      minLengthChars: 'Type to search (min {{length}} characters)...',
      organization: 'Enter your Organization',
      peakFord: 'Enter your Password',
      priceOverRide: 'Max Discount (%)',
      search: 'Search',
      selectADevice: 'Select a Device',
      selectATender: 'Select a Tender',
      selectPaidTender: 'Select a Paid Tender',
      selectRefundTender: 'Select a Refund Tender',
      enterAnAmount: 'Enter an Amount',
      enterAPriority: 'Enter a Priority',
      selectATime: 'Select a Time',
      selectAType: 'Select a Type',
      selectActionType: 'Select Action Type',
      selectAlertGroup: 'Select Alert Group',
      selectAdditionalCode: 'Select Additional Code',
      selectAlertTemplate: 'Select Alert Template',
      selectAlertTemplateId: 'Select Alert Template Id',
      selectAlgorithm: 'Select Algorithm',
      selectBeginDate: 'Select Begin Date',
      selectCategories: 'Select Categories',
      selectCategory: 'Select Category',
      selectCheckValidator: 'Select Check Validator',
      selectConvertedCurrency: 'Select Converted Currency',
      selectCulture: 'Select Culture',
      selectCurrency: 'Select Currency',
      selectCurrencyCode: 'Select Currency Code',
      selectDateTimeFormat: 'Select Date Time Format',
      selectDescription: 'Select Description',
      selectEffectiveDate: 'Select Effective Date',
      selectEndDate: 'Select End Date',
      selectExcludedLocations: 'Select Excluded Locations',
      selectGroups: 'Select Groups',
      selectIncludedGroups: 'Select Included Groups',
      selectIncludedLocations: 'Select Included Locations',
      selectInputType: 'Select Input Type',
      selectItems: 'Select Items',
      selectLanguage: 'Select a Language',
      selectLimitValueType: 'Select Limit Value Type',
      selectLocation: 'Select Location',
      selectLocations: 'Select Locations',
      selectLoyaltyCard: 'Select Loyalty Card',
      selectMaxMin: 'Select Min./Max.',
      selectMaxPeriod: 'Select Max. Period',
      selectMessage: 'Select Message',
      selectMethod: 'Select Closing Method',
      selectParameters: 'Select Parameters',
      selectPayWithTenders: 'Select Tenders to Pay With',
      selectPeriodType: 'Select Period Type',
      selectProduct: 'Select Product',
      selectProducts: 'Select Products',
      selectProvider: 'Select Provider',
      selectProviderMessage: 'Select Provider Message',
      selectReasonCode: 'Select Reason Code',
      selectRefundTenders: 'Select Refund Tenders',
      selectRejectReason: 'Select Reject Reason',
      selectRelation: 'Select Relation',
      selectRole: 'Select Role',
      selectARole: 'Select a Role',
      selectRoles: 'Select Roles',
      selectSeverity: 'Select Severity',
      selectStartDate: 'Select Start Date',
      selectStatus: 'Select Status',
      selectStoreHierarchy: 'Select Store Hierarchy',
      selectTemplate: 'Select Alert Template ID',
      selectTenderName: 'Select Tender Name',
      selectTenderToPayWith: 'Select Tenders to Pay With',
      selectTenderType: 'Select Tender Type',
      selectTenders: 'Select Tenders',
      selectTendersToPayWith: 'Select Tenders to Pay with',
      selectTime: 'Select a time',
      selectTouchpointApp: 'Select Touchpoint App',
      selectTouchpointApplication: 'Select Touchpoint Application',
      selectTouchpointGroup: 'Select Touchpoint Group',
      selectTouchpointGroups: 'Select Touchpoint Groups',
      selectTransactionType: 'Select Transaction Type',
      selectType: 'Select Type',
      selectTypeAbove: 'Please select a type above.',
      selectTypeAutocomplete: 'Type to Search',
      typeToSearch: 'Type to Search...',
      upToAmount: 'Up to Amount',
      username: 'Enter your Username',
      zeroDollarsZeroCents: '$ 0.00',
    },
    filter: {
      presentedResults: '{{length}} {{name}} presented',
      noResults: 'No Results Found',
      selectAll: 'Select All',
      removeAll: 'Remove All',
      clear: 'clear',
    },
    header: {
      available: 'Available {{name}}',
    },
    title: {
      add: 'Add {{title}}',
      addNew: 'Add New {{title}}',
      addNewTender: 'New Tender',
      addStore: 'Add New Store',
      addTranslation: 'Add Translation',
      alertTemplate: 'Alert Template',
      alertTemplates: 'Alert Templates',
      allowedActivities: 'Allowed Activities',
      approvalRequires: 'Approval Required',
      basicDefinition: 'Basic Definition',
      brackets: 'Brackets',
      branding: 'Brand & Layout',
      businessDayScheduler: 'Business Day Scheduler',
      businessPeriodsConfiguration: 'Business Periods Configuration',
      cashOffice: 'Cash Office',
      catalinaConfigurations: 'Catalina Configurations',
      clear: 'Clear',
      communicationSettings: 'Communication Settings',
      contactAndLocation: 'Contact and Location',
      cultureSettings: 'Culture Settings',
      currencies: 'Currency',
      currency: 'Currency',
      currencyList: 'Currency List',
      dataPatterns: 'Data Patterns',
      delayedApproval: 'Delayed Approval',
      denominationWithCurrency: 'Denominations - {{currencyCode}}',
      device: 'Device',
      displayConfigurations: 'Touchpoint Branding',
      duplicateBusinessDay: 'Duplicate Record',
      editActiveTheme: 'Edit Active Config?',
      editAgeRestrictedPolicy: 'Edit Policy', // PolicyMembers.tsx
      editSomething: 'Edit {{something}}',
      editStore: 'Edit Store',
      editTender: 'Edit Tender',
      endOfDayActivities: 'End of Day Activities',
      errorFromServer: 'Error from server',
      excludedItems: 'Excluded items',
      feeDetails: 'Fee Details',
      fuelPrepaySettings: 'Fuel Prepay Settings',
      groupList: 'Group List',
      hierarchy: 'Hierarchy',
      hipaa: 'HIPAA',
      itemPickerModal: 'Browse or Look Up Item',
      jarvisSelfCheckout: 'Jarvis Self - Checkout',
      keyBinding: 'Key Bindings',
      keyboardProgramming: 'Keyboard Programming',
      messages: 'Messages',
      newAgeRestrictedPolicy: 'New Policy', // PolicyMembers.tsx
      newSomething: 'New {{something}}',
      onSelfCheckout: 'On Self-Checkout:',
      onlinePurchaseProfile: 'Online Purchase Profile',
      openAmountStrategy: 'Open Amount Strategy',
      operations: 'Operations',
      organization: 'Organization',
      pharmacyPolicies: 'Pharmacy Policies',
      pluGroups: 'PLU Groups',
      policyMembers: 'Policy Members', // PolicyMembers.tsx
      printingDefinitions: 'Printing Definitions',
      reasonCodes: 'Reason Codes',
      recognizers: 'Recognizers',
      resolveValidationErrors: 'Please resolve all validation errors!',
      results: 'Results',
      sales: 'Sales',
      save: 'Save',
      searchResults: 'Search Results',
      selections: 'Selections',
      sellableMedia: 'Sellable Media',
      serverError: 'Error from server',
      somethingWentWrong: 'Something went wrong',
      stores: 'Stores',
      strategy: 'Strategy',
      taxAssociation: 'Tax Association',
      taxAuthorities: 'Tax Authorities',
      taxBrackets: 'Tax Brackets',
      taxParameters: 'Tax Exemption Parameters',
      taxRates: 'Tax Rates',
      taxZones: 'Tax Zones',
      tenderAmount: 'Tender Amount',
      tenderExchange: 'Tender Exchange',
      tenderFeePolicy: 'Tender Fee Policy',
      tenderFeeList: 'Tender Fee List',
      tenderItemRestriction: 'Tender Item Restriction',
      touchPointDevices: 'Devices',
      touchpoint: 'Touchpoint',
      touchpointGroups: 'Touchpoint Groups',
      touchpoints: 'Touchpoints',
      touchpointsApplications: 'Touchpoints Applications',
      touchpointsDevices: 'Devices',
      unsavedData: 'Unsaved Data',
      utilities: 'Utilities',
      validators: 'Validators',
      value: 'Value',
      websiteName: 'Central Configuration Manager',
    },
    subtitle: {
      tenderFeePolicy:
        'Define a policy fee by creating a new “Policy Fee list” or edit an existing group',
    },
    weekdays: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    pages: {
      usWicTendering: {
        searchScreen: {
          enabled: 'Enabled',
          disabled: 'Disabled',
          title: 'WIC Agencies',
          addAgency: '+ Add WIC Agency',
          labels: {
            agency_name: 'Agency Name',
            state_code: 'State Code',
            type: 'Type',
            status: 'Status',
          },
          placeholders: {
            agency: 'Enter Agency',
            state_code: 'Select a code',
            type: 'Select a type',
          },
          clear: 'Clear',
          offline: 'Offline',
          online: 'Online',
        },
      },
      ageRestriction: {
        title: 'Age Restricted Policy',
        editTitle: 'Edit Policy',
        onDelete: 'Deleted!',
        onSuccessfulSave: 'A new Policy has been created',
        onSuccessfulUpdate: 'Policy was Updated',
        sections: {
          generalSettings: {
            title: '',
            delayRadioTitle: 'Delay message in self-checkout',
            returnItemTitle: 'Applies also for return item',
          },
          customerAge: {
            title: 'Customer Age',
            actionType: 'Age Confirmation Action Type',
            ActionTypeApproveReject: 'Approve / Reject',
            actionTypeDOB: 'Enter Date Of Birth',
            actionTypeDOBApproveReject: 'Enter DoB / Approve / Reject',
            actionTypePlaceHolder: 'Please select...',
            autoRejectMessage: 'Message for automatic reject',
            customerAge: 'Customer Age is less than...',
            customerAgePlaceHolder: 'Enter Customer Age',
            rejectReason: 'Reject Reason Codes',
          },
          dateTime: {
            title: 'Date Time',
            actionType: 'Action Type',
            actionTypeApproval: 'Approval Required',
            actionTypeProhibit: 'Prohibit',
            actionTypePlaceHolder: 'Please select...',
            addAnotherDate: 'Add Another Date',
            addAnotherTime: 'Add Another Time',
            dates: {
              noEndDate: 'No end date',
            },
            days: {
              sunday: 'Sunday',
              monday: 'Monday',
              tuesday: 'Tuesday',
              wednesday: 'Wednesday',
              thursday: 'Thursday',
              friday: 'Friday',
              saturday: 'Saturday',
            },
            times: {
              noEndTime: 'No end time',
            },
          },
          policyMembers: {
            title: 'Policy Members',
            productCategory: 'Products & Categories',
            groups: 'Groups',
            category: 'Category',
            products: 'Products',
            includedLocations: 'Included Locations',
            excludedLocations: 'Excluded Locations',
            selectCategory: 'Select Category',
            placeholder: {
              enterPolicyId: 'Enter Policy Id',
              selectLocation: 'Select Location',
              selectCategory: 'Select Category',
              selectTouchpointGroups: 'Select Touchpoint Groups',
              selectGroups: 'Select Groups',
            },
          },
          restrictedPolicy: {
            location: 'Location',
            policyId: 'Policy ID',
          },
          searchScreen: {
            addPolicy: '+ Add Policy',
            title: 'Age Restrictions',
            policyId: 'Policy ID',
            location: 'Location',
            edit: 'Edit',
            delete: 'Delete',
          },
          error: {
            policyMembersReq: 'Policy Members are required',
            actionTypeReq: 'Action Type is a required field',
            startDateReq: 'Start Date is a required field',
            startDateOrDaysReq: 'Please fill Start Date or Time or Days of the week or both',
            messageReq: 'Message is a required field',
            sectionReq: 'Please fill Date Time or Customer Age',
          },
        },
        placeholder: {
          addHeader: {
            policyId: 'Enter Policy ID',
            locationPicker: 'Select Locations',
            touchpointGroupSelect: 'Select Groups',
            groupSelect: 'Select Groups',
          },
          selectDaysOfWeek: 'Select Days of week',
          selectDate: 'Select a date',
        },
      },
      businessDayScheduler: {
        list: {
          title: 'Business Day Scheduler',
          filters: {
            locationLabel: 'Location',
            locationPlaceholder: 'Select Location',
          },
          addNew: 'Add new Business Day Scheduler',
        },
        details: {
          onSuccessfulCreate: 'A new Business Day Scheduler has been created',
          onSuccessfulUpdate: 'Business Day Scheduler was updated',
          title: {
            add: 'New Business Day Scheduler',
            edit: 'Edit Business Day Scheduler',
          },
          fields: {
            enterpriseUnitId: {
              label: 'Location',
              placeholder: 'Select Location',
            },
          },
          tabs: {
            default: 'Default',
            exceptions: 'Exceptions',
          },
          reoccurrencePattern: {
            title: 'Reoccurrence Pattern',
            checkboxNextDay: 'Next Day',
            checkboxIgnore: 'Ignore',
            endsOn: "Ends on {{day}} {{time}}"
          },
          excludedDates: {
            title: 'Excluded Dates'
          },
          exceptions: {
            exception: 'Exception',
            addExceptionBtn: 'Add Exception',
            deleteException: 'Delete Exception',
            emptyStartTitle: 'There are currently no Exceptions.'
          }
        },
        validation: {
          touchpointGroups: 'Touchpoint Groups field is required',
        },
      },
      businessRules: {
        editTitle: 'Edit Business Rule',
        onSuccessfulSave: 'A new Business Rule has been created',
        onSuccessfulUpdate: 'Business Rule was Updated',
        sections: {
          productCondition: {
            transactionType: 'Select Transaction Type',
            selectCategories: 'Select Categories',
            selectGroups: 'Select Groups',
          },
          searchScreen: {
            ruleId: 'Name',
            ruleType: 'Type',
            edit: 'Edit',
            delete: 'Delete',
          },
          actions: {
            actionTitle: 'Select Action Type',
            inputDataRequired: {
              text: 'Text',
              yesNo: 'Yes/No',
              date: 'Date',
              birthday: 'Birthday',
              numeric: 'Numeric',
            },
          },
          preconditionRule: {
            quantitativeLimit: {
              aggregateOn: 'Aggregate On',
            },
            recallTransaction: {
              maxRecall: 'Max recall time (hours)',
              limitRecall: 'Limit recall for the same business day',
              tooltipRecall: 'Setting this field to \'YES\' will allow to recall only transactions that have been suspended within the same business day (i.e. before end of day process has been completed). In order to complete business rule definition, at least one of the following should be done: Set this field to \'YES\' OR fill in \'Max recall time\' field.',
            },
            suspendTransaction: {
              suspend: 'Apply only if transaction contains authorized online items',
            },
          },
        },
        buttons: {
          addNewBusinessRule: 'Add Business Rule',
        },
        title: {
          businessRules: 'Business Rules',
          ruleName: 'Name',
        },
        placeholder: {
          ruleName: 'Enter Name',
          ruleType: 'Select Rule Type',
        },
        label: {
          ruleName: 'Name',
          ruleType: 'Type',
        },
        notifications: {
          businessRulesAdded: 'A new business rule has been created.',
          businessRulesSaved: 'Business rule has saved.',
        },
      },
      commandsMenu: {
        list: {
          title: 'Command Menu',
          addNew: 'Add new Command Menu',
          filters: {
            locationLabel: 'Location',
            locationPlaceholder: 'Filter by Location',
            touchpointGroupLabel: 'Touchpoint Group',
            touchpointGroupPlaceholder: 'Filter by a Touchpoint Group',
            touchpointApplicationLabel: 'Touchpoint Application',
            touchpointApplicationPlaceholder: 'Filter by Touchpoint Application',
            menuIdLabel: 'Name',
            menuIdPlaceholder: 'Filter by Name',
            menuTypeLabel: 'Menu Type',
            menuTypePlaceholder: 'Filter by Menu Type',
            commandIdLabel: 'Command ID',
            commandIdPlaceholder: 'Filter by Command ID',
            activeOnly: 'Active Only',
          },
        }
        },
      dataPatterns: {
        search: {
          title: 'Data Pattern',
          searchHeader: {
            placeholder: {
              prefixField: 'Enter Prefix',
              lengthField: 'Enter Length',
              typeField: 'Select Type',
              storeField: 'Select Store Hierarchy',
              barcodeField: 'Enter Barcode',
            },
          },
          addNew: 'Add Data Pattern',
        },
        add: {
          addHeader: {
            placeholder: {
              idField: 'Enter New Indicator',
              descriptionField: 'Enter Description',
              typeField: 'Select Type',
              locationField: 'Select Location',
            },
          },
          validation: {
            required: 'Required',
            decodingLength: 'Must contain at least 1 prefix',
            requiredValue: 'Each prefix must have either Fixed value or From-To range values',
          },
        },
      },
      displayConfigurations: {
        onSuccessfulSave: 'A new Display Configuration has been created',
        onSuccessfulUpdate: 'Display Configuration was Updated',
      },
      returnPolicies: {
        duplicateReturnPolicy: 'Duplicate Return Policy',
        editTitle: 'Edit Return Policy',
        newTitle: 'New Return Policy',
        editPolicy: {
          reasonCodesTitle: 'Reason Codes',
          returnPolicyTitle: 'Return Policy',
          addRestriction: 'Add Restriction',
          bestFor: 'Return Best For:',
          customer: 'Customer',
          draft: 'Draft',
          eachItem: 'For Each Item',
          itemAttributes: 'Item Attributes',
          location: 'Location',
          locationPlaceHolder: 'Select Location',
          never: 'Never',
          policyName: 'Policy Name',
          policyNamePlaceHolder: 'Enter Policy Name',
          promptReasonCode: 'Prompt for Reason Codes',
          publish: 'Publish',
          published: 'Published',
          receiptSearch: 'Receipt Search Time Frame',
          restrictionName: 'Name',
          retailer: 'Retailer',
          rpTypePlaceholder: 'Select Return Policy Type',
          startDate: 'Start Date',
          startDatePlaceholder: 'Select a Date',
          selectDatePlaceholder: 'Select a date',
          selectCodePlaceholder: 'Select a code',
          endDate: 'End Date',
          endDatePlaceholder: 'Select a Date',
          startTime: 'Start Time',
          startTimePlaceholder: 'Select Time',
          endTime: 'End Time',
          endTimePlaceholder: 'Select a Time',
          saveDraft: 'Save as Draft',
          selectPolicyType: 'Select Policy Type',
          status: 'Status',
          timeError:
            'Invalid end date/time. End date/time should be later than defined start date/time',
          timePassedError:
            'Cannot define a return policy for a date/time that has passed. Please refine date/time criteria',
          type: 'Return Policy Type',
          expandableCards: {
            basicDefinitions: 'Basic Definitions',
          },
          restrictions: {
            categories: 'Categories',
            groups: 'Groups',
            products: 'Products',
          },
          returnRules: {
            actionType: {
              approve: 'Approval Required',
              label: 'Action Type',
              prohibit: 'Prohibit',
              actionTypePlaceHolder: 'Select Action Type',
            },
            messages: {
              label: 'Message',
              addLabel: 'Create New Message',
            },
            validation: {
              actionType: 'Action Type is Required',
              attribute: 'Item Attribute is Required',
              message: 'Message is Required',
              restrictionName: 'Restriction Name is Required',
              roles: 'Roles is Required',
              sameAttribute: 'This Attribute Type Already Exists',
              scope: 'Scope is Required',
            },
            scope: {
              request: 'Request',
              transaction: 'Transaction',
              label: 'Scope',
              placeHolder: 'Select Scope',
            },
          },
          validation: {
            location: 'Locations are Required',
            policyName: 'Policy Name is Required',
            searchTime: 'Receipt Search Time Frame is a required field',
            searchTimeMax: 'maximum 2147483647',
            searchTimeMin: 'minimum 0',
            type: 'Return Policy Type is Required',
          },

          tabs: {
            details: 'Details',
            restrictions: 'Restrictions',
          },
          types: {
            transactionBased: 'Transaction Based',
            nonReceiptedReturn: 'Non Receipted',
            bottleDeposit: 'Bottle Deposit',
          },
          table: {
            reasonCodes: 'Reason Codes',
            products: 'Products',
            categories: 'Categories',
            productDescription: 'Product Description',
            reasonAssociationsError: 'Table must be populated',
            noValueError: 'No value entered',
            selectCodePlaceholder: 'Select a code',
          },
        },
        notifications: {
          deleted: 'Return Policy Has Been Deleted',
          duplicated: 'Return Policy Has Been Duplicated Successfully',
          published: 'Return Policy Has Been Updated And Published',
          newPublished: 'A New Return Policy Has Been Published',
          newSaved: 'A New Return Policy Has Been Saved',
          restriction: 'Return Policy Restriction Has Been Saved',
          updated: 'Return Policy Has Been Updated',
        },
        searchScreen: {
          title: 'Return Policies',
          addPolicy: '+ Add Return Policy',
          searchTable: {
            policyName: 'Policy Name',
            activationPeriod: 'Activation Period',
            policyType: 'Policy Type',
            status: 'Status',
            locations: 'Locations',
          },
          actions: {
            duplicate: 'Duplicate',
            publish: 'Publish',
          },
        },
        addRestriction: {
          action: 'Action',
          actionPlaceholder: 'Select Action Type',
          actionType: 'Action Type',
          actionText:
            'Define the action which should take place when items with the above attributes are returned.',
          addAttribute: 'ADD ATTRIBUTE',
          and: 'and',
          category: 'Categories',
          condition: 'Condition',
          dropdownPlaceholder: 'Select Attribute',
          exclude: 'Exclude',
          groups: 'Groups',
          include: 'Include',
          itemAttribute: 'Attribute',
          message: 'Message',
          namePlaceHolder: 'Enter Restriction Name',
          product: 'Products',
          roles: 'Roles',
          allowedRolestoSwitch: 'Allowed Roles to Switch',
          ruleName: 'Restriction Name',
          scope: 'Scope',
          subtitle1:
            "Please enter the information below to add the return policy. Restrictions are based on items' attributes and the",
          subtitle2:
            'action that is taken when items with these attributes are added to a transaction.',
          title: 'Create Return Policy Restriction',
        },
        businessUnits: {},
        nonReceiptedTenderSection: 'Non Receipted Tender',
        recommendedTender: 'Recommended Tenders',
        nonReceiptedTender: {
          refundTender: 'Refund Tender',
          upToAmount: 'Up to Amount',
        },
        recommendedTenders: {
          paidTender: 'Paid Tender',
          refundTender: 'Refund Tender',
          upToAmount: 'Up to Amount',
          priority: 'Priority',
        },
      },
      currencyExchangeRates: {
        title: 'Currency Exchange Rate',
        addNew: 'Add Currency Exchange Rate',
        labels: {
          baseCurrency: 'Base Currency',
          convertedCurrency: 'Converted Currency',
          effectiveDate: 'Effective Date',
          rate: 'Rate',
          lastUpdated: 'Last Updated',
        },
      },
      onlinePurchaseProfile: {
        add: {
          commSettings: 'Communication Settings',
          placeholder: {
            name: 'Enter Name',
            provider: 'Select Provider',
            providerMessage: 'Select Provider Message',
          },
        },
      },
      stores: {
        storeDetails: {
          label: {
            storeName: 'Store Name',
            country: 'Country',
            timeZone: 'Time Zone',
            postalCode: 'Zip Code',
            phoneNumber: 'Phone',
            faxNumber: 'Fax',
            contactPerson: 'Contact Person',
            bankAccount: 'Bank Account Number',
          },
          placeholder: {
            enterStoreName: 'Enter Store Name',
            enterCountry: 'Enter Country',
            enterTimeZone: 'Enter Time Zone',
            enterPostalCode: 'Enter Zip code',
            enterPhoneNumber: 'Enter Phone number',
            enterFaxNumber: 'Enter Fax number',
            enterContactPerson: 'Enter Contact Person',
            enterBankAccount: 'Enter Bank Account Number',
          },
        },
      },
      PLUGroups: {
        filters: {
          nameLabel: 'Name',
          namePlaceholder: 'Search by Name',
          locationLabel: 'Location',
          locationPlaceholder: 'Select a location',
        },
        tableInfo: {
          empty: 'empty',
          pluItems: '{{count}} PLU Item',
          pluItems_plural: '{{count}} PLU Items',
          pluSubgroups: '{{count}} PLU Subgroup',
          pluSubgroups_plural: '{{count}} PLU Subgroups',
        },
        details: {
          emptyTitle: 'The PLU Group is empty.',
          emptySubtitle: "Choose what PLU type you'd like to add",
          emptyPLUItemsBtn: 'PLU Items',
          emptyPLUGroupsBtn: 'PLU Groups',
          onSuccessfulCreate: 'A new PLU Group has been created',
          onSuccessfulUpdate: 'PLU Group was Updated',
          pluSubGroups: 'PLU Subgroups ({{count}})',
        },
        subgroupsModal: {
          title: 'Add New PLU Subgroup',
          labelChoosePLU: 'Chose PLU Group',
          labelExistingPLU: 'Existing PLU Group',
          labelNewPLU: 'New PLU Group',
          placeholderSearch: 'Search',
          tableColumn: 'PLU Groups',
          selectPLUGroup: 'Please select a PLU Group',
          empty: 'empty',
          pluItems: '{{count}} item',
          pluItems_plural: '{{count}} items',
          pluSubgroups: '{{count}} subgroup',
          pluSubgroups_plural: '{{count}} subgroups',
        },
        items: {
          title: 'PLU Items ({{count}})',
          add: 'Add PLU Item',
        },
        errors: {
          locationRequired: 'Location is required when adding items',
        },
      },
      PLUMenu: {
        filters: {
          menuLabel: 'Menu',
          menuPlaceholder: 'Enter a Menu',
          locationLabel: 'Location',
          locationPlaceholder: 'Select a location',
          productLabel: 'Product',
          productPlaceholder: 'Add Product',
          touchpointApplicationLabel: 'Touchpoint Application',
          touchpointApplicationPlaceholder: 'Select Touchpoint Application',
          touchpointGroupLabel: 'Touchpoint Group',
          touchpointGroupPlaceholder: 'Select Touchpoint Group',
          active: 'Active',
          inactive: 'Inactive',
          showActiveOnly: 'Show Active Only',
          showSelectedOnly: 'Show Selected Only'
        },
        labels: {
          pluUpdated:'PLU Menu Update',
          pluUpdatedMsg:'New PLU Items/Groups added ,Save Menu .',
          pluMenus: 'PLU Menus',
          pluMenu: 'PLU Menu',
          name: 'Name',
          description: 'Descriptions',
          status: {
            active: 'Active',
            inactive: 'Inactive',
          },
        },
        placeHolders: {
          name: 'Add Name',
          description: 'Add Descriptions'
        },
        notifications: {
          pluMenuAdded: 'A new PLU Menu has been created.',
          pluMenuSaved: 'PLU Menu have been updated.',
        },
        tabs: {
          AssociatedPLUGroup: {
            tabTitle: 'Associated PLU Group',
            locationsFilter: 'Filter by Location'
          },
          PLUAssignment: {
            tabTitle: 'PLU Assignment',
            placeHolder: {
              touchpointApplicationPlaceholder: 'Select Touchpoint Applications',
            }
          },
          ManagePluMenu: {
            tabTitle: 'Arrange PLU Menu ',
            modeOptions: {
              condensed: 'Condensed',
              regular: 'Regular',
              elaborated: 'Elaborated'
            },
            sortingOptions: {
              manual: 'Manual',
              alphabet: 'A → Z'
            },
            labels: {
              pluItems: 'PLU Items',
              pluSubgroups: 'PLU Subgroups',
              pluGroups: 'PLU Groups',
              empty: 'Empty'
            },
            toolTip: {
              condensed: 'Condensed - Description and Id',
              regular: 'Regular - Description And Price',
              elaborated: 'Elaborated - description, Id and Price'
            },
            noResults: {
              search: 'No results found.',
              dnditems: 'There are currently no selected items in the PLU menu.',
              noMenus: 'There are currently no items in the PLU menu.',
              groupItems: 'The PLU Group is included in the menu, but no longer exists in the system. ',
              emptyGroup1: 'The PLU Group you selected is currently empty.',
              emptyGroup2: 'You can add items and edit in the PLU Groups feature. '
            },
            card: {
              noNameItem: 'Unnamed Item',
              noNameGroup: 'Unnamed Group'
            }

          }
        },
      },
      touchPoint: {
        devices: {
          touchPoint: 'Touchpoint',
          touchPointsTitle: 'Touchpoints',
          add: {
            configurationData: 'Configuration Data',
            placeholder: {
              touchPointID: 'Enter Touchpoint ID',
              description: 'Enter Description',
              deviceType: 'Select Device Type',
            },
            label: {
              touchPointID: 'Touchpoint ID',
              epsControl: 'Controlled by EPS',
              description: 'Description',
              deviceType: 'Device Type',
            },
          },
        },
        deviceTypes: {
          title: 'Device Types',
          addDeviceType: 'Add Device Type',
          placeholder: {
            selectTemplate: 'Select Alert Template ID',
            selectMethod: 'Select Closing Method',
          },
        },
        touchPointGroup: {
          addNew: 'Add Touchpoint Group',
        },
        touchPoints: {
          newTouchpointTitle: 'New Touchpoint',
          editTouchpointTitle: 'Edit Touchpoint',
          notifications: {
            add: 'A New Touchpoint has been Created.',
            update: 'Touchpoint was Updated.',
          },
        },
      },
      taxBrackets: {
        ratesTitle: 'Rates',
        addNewRate: 'Add Rate',
        placeholder: {
          enterKey: 'Enter Key',
          enterValue: 'Enter Values',
          'enterError Code': 'Enter Error Code',
        },
      },
      tenderItemRestriction: {
        add: {
          displayTenderBalanceOnTotal: 'Display Tender Balance On Total',
          returnItemReducesEligibility: 'Return Item Reduces Eligibility',
          allowReverseEligibility: 'Allow Reverse Eligibility',
        },
      },
      taxRates: {
        filters: {
          rateIdLabel: 'Rate ID',
          authorityLabel: 'Authority',
          productGroupLabel: 'Product Group',
          typeLabel: 'Type',
          dateRangeLabel: 'Date Range',
          locationLabel: 'Location',
          taxZonesLabel: 'Tax Zone',
          rateIdPlaceholder: 'Enter Rate ID',
          authorityPlaceholder: 'Select Authority',
          productGroupPlaceholder: 'Select Product Group',
          typePlaceholder: 'Select Type',
          dateRangePlaceholder: 'Select Date Range',
          locationPlaceholder: 'Select Location',
          taxZonesPlaceholder: 'Select Tax Zone',
        },
        details: {
          onSuccessfulCreate: 'A new Tax rate has been created',
          onSuccessfulUpdate: 'Tax Rate was updated',
          title: {
            add: 'New Tax Rate',
            edit: 'Edit Tax Rate',
          },
          fields: {
            rateId: {
              label: 'Rate ID',
              placeholder: 'Select Rate ID',
            },
            descriptions: {
              label: 'Description',
              placeholder: 'Enter Description',
            },
            authority: {
              label: 'Authority',
              placeholder: 'Select Authority',
            },
            taxType: {
              label: 'Type',
              placeholder: 'Select Type',
            },
            taxHierarchy: {
              label: 'Tax Hierarchy',
              placeholder: 'Select Tax Hierarchy',
            },
          },
          conditions: {
            panelTitle: 'Conditions',
          },
          calculation: {
            panelTitle: 'Calculation',
            method: 'Method',
            methodPlaceholder: 'Select a method',
            fixed: 'Fixed',
            percent: 'Percent',
            value: 'Value',
            valuePlaceholder: 'Enter a value',
            inclusive: 'Inclusive',
            on: 'On',
            off: 'Off',
            rounding: 'Rounding Method',
            roundingPlaceholder: 'Select a rounding method',
            standard: 'Standard',
            up: 'Up',
            down: 'Down',
            none: 'None',
            indicator: 'Indicator',
            indicatorPlaceholder: 'Enter an indicator value',
            imposition: 'Imposition',
            impositionPlaceholder: 'Enter an imposition value',
            coupon: 'Coupon reduces tax amount',
          },
          columnTitle: {
            entityType: 'Entity Type',
            entityCode: 'Entity Code',
            entityDescription: 'Entity Description',
            hierarchyType: 'Hierarchy Type',
          },
          buttonTitle: {
            addGroup: 'Add Group',
            addHierarchy: 'Add Hierarchy',
            addItem: 'Add Item',
          },
          panels: {
            productExclusion: 'Product Exclusion',
          },
        },
        errors: {
          format: 'Date Range format is invalid({{dateFormat}} - {{dateFormat}})',
          greater: 'End date should be greater than Start date',
          serverUnavailable: 'The Catalog server is temporarily unavailable',
          notFound: 'This {{type}} code may be uncataloged',
        },
      },
      taxZones: {
        filters: {
          zoneNameLabel: 'Zone Name',
          zoneNamePlaceholder: 'Enter a Zone Name',
          locationLabel: 'Location',
          locationPlaceholder: 'Select a location',
        },
        table: {
          zoneNameLabel: 'Zone Name',
          zoneNamePlaceholder: 'Enter Zone Name',
          locationLabel: 'Location',
          locationPlaceholder: 'Select a location',
        },
      },
      tenders: {
        tenderTypes: {
          cash: 'Cash',
          voucher: 'Voucher',
          creditdebit: 'CreditDebit',
          cheque: 'Cheque',
          check: 'Check',
          mobile: 'Mobile',
          reward: 'Reward',
          ewic: 'eWIC',
        },
        tenderMain: {
          tabs: {
            defaults: 'Defaults',
            exceptions: 'Exceptions',
          },
        },
        exceptions: {
          sectionTitle: 'Exceptions',
          addExceptionButton: 'Add Exception',
          noExceptions: 'There are currently no exceptions for the tender.',
          addDefinitionButton: 'Add Definition',
          exceptionTypeLabel: 'Exception Type',
          exceptionTypePlaceholder: 'Select Exception Type',
          touchpointGroupsLabel: 'Touchpoint Groups',
          touchpointGroupsPlaceholder: 'Select Touchpoint Groups',
          messageLabel: 'Message',
          messagePlaceholder: 'Select Message',
          exceptionTypes: {
            prohibitOverTender: 'Prohibit Over Tender',
            prohibitPayment: 'Prohibit Payment',
            prohibitRefund: 'Prohibit Refund',
            prohibitVoid: 'Prohibit Void',
          },
        },
      },
      tenderMenu: {
        editPage: {
          droppableEmpty: 'Drag Tenders and Tender Groups here to create your menu',
          droppableTitle: 'Main Menu',
          editTitle: 'Edit Tender Menu',
          location: 'Location',
          locationPlaceholder: 'Select Location',
          menuName: 'Name',
          menuNamePlaceholder: 'Enter Tender Group Name',
          newTitle: 'New Tender Menu',
          notifications: {
            created: 'A new Tender Menu has been created',
            deleted: 'Tender Menu has been deleted',
            updated: 'Tender Menu has been Updated',
          },
          status: {
            active: 'Active',
            inactive: 'Inactive',
          },
          tendersVoided: 'The following tenders/tender groups have been voided and removed:   ',
          touchPointApplication: 'Touchpoint Application',
          touchPointApplicationPlaceHolder: 'Select Touchpoint Application',
          touchPointGroup: 'Touchpoint Group',
          validation: {
            name: 'Name is Required',
          },
        },
        newTenderGroup: '+ New Tender Group',
        status: {
          active: 'Active',
          inactive: 'Inactive',
        },
      },
      sales: {
        plu: {
          pluGroups: {
            detailsPLUGroups: {
              title: {
                add: 'Add PLU Group',
                edit: 'Edit PLU Group',
              },
              fields: {
                name: 'Name',
                placeHolderName: 'Enter Name',
                description: 'Description',
                placeHolderDescription: 'Enter Description',
                location: 'Location',
                placeHolderLocation: 'Select Location',
              },
            },
          },
          pluMenu: {
            labels: {
              name: 'Name',
              description: 'Description',
              status: {
                active: 'Active',
                inactive: 'Inactive',
              },
            },
            placeholder: {
              name: 'Name',
              description: 'Description',
            },
            tabs: {
              AssociatedPLUGroup: {
                title: 'Select PLU Groups',
                search: 'Search'
              },
              PluAssignment: {
                title: 'PLU Menu Assignment',
                placeHolders: {
                  touchpointApplicationPlaceholder: 'Touchpoint Type'
                },
              }
            },
          }
        },
        wicAgency: {
          editPage: {
            disabled: 'Disabled',
            enabled: 'Enabled',
            notifications: {
              created: 'A new WIC Agency has been created',
              updated: ' WIC Agency has been updated',
            },
            offline: 'Offline',
            online: 'Online',
            name: 'Agency Name',
            namePlaceholder: 'Enter Agency Name',
            radioStatus: 'Status',
            stateCode: 'State Code',
            stateCodePlaceholder: 'Enter a code',
            status: 'Enabled',
            titleEdit: 'Edit WIC Agency',
            titleNew: 'New WIC Agency',
            type: 'Type',
            typePlaceholder: 'Select a type',
          },
          validation: {
            name: 'Agency Name is required',
            stateCode: 'State Code is required',
            stateCodeLength: 'Maximum 2 characters',
            type: 'Type is required',
          },
        },
      },
      wicEbtPolicy: {
        merchantDiscount: 'Include Merchant Discount in item price',
        title: 'WIC EBT Policy',
        yesOption: 'Yes',
      },
      wicCVBMappings: {
        title: 'WIC CVB Product Mapping',
        warningMessage: `Displaying only the first 500\nproducts of search results.\n\nPlease refine the criteria to see \nmore results.`,
        alertMessage: 'Showing only the first 500 results',
        duplicateMessage: `Product {{ mappedItemCode}} {{catalogDescription}} has already been mapped to APL product {{ upcOrPluCode}} {{itemDescription}}`,
        duplicateTitle: 'Mapping Error',
        header: {
          agencyLabel: 'Agency',
          agencyPlaceHolder: 'Select Agency',
          isMapped: {
            showAll: 'Show All',
            mapped: 'Mapped',
            unmapped: 'Unmapped',
          },
          categoryLabel: 'Category',
          subCategoryLabel: 'Sub-Category',
          subCategoryPlaceHolder: 'Select Subcategory',
          aplCodeLabel: 'APL Code / Description',
          aplCodePlaceHolder: 'Enter Code or Description',
        },
        content: {
          aplTableTitle: 'APL Products',
          aplTableCode: 'APL Product Code',
          aplTableName: 'APL Product Name',
          aplTableMapped: 'Mapped',
          itemPickerButton: '+ Add Product',
          productTableBarcode: 'Barcode',
          productTableName: 'Product Name',
          productTableEmpty:
            'There are currently no products that have\nbeen mapped to the selected APL product',
          productTableTitle: 'Mapped Catalog Products',
          refineSearch: 'Please refine search to populate results',
          removeButton: 'Remove',
          selected: 'Selected',
        },
      },
      wicProductExclusions: {
        title: 'WIC Product Exclusions',
        warningMessage: `Displaying only the first 100\nproducts of search results.\n\nPlease refine the criteria to see \nmore results.`,
        alertMessage: 'Showing only the first 100 results',
        header: {
          agencyLabel: 'Agency',
          agencyPlaceHolder: 'Select Agency',
          isExcluded: {
            showAll: 'Show All',
            excluded: 'Excluded',
            unExcluded: 'Unexcluded',
          },
          categoryLabel: 'Category',
          categoryPlaceHolder: 'Select Category',
          subCategoryLabel: 'Sub-Category',
          subCategoryPlaceHolder: 'Select Subcategory',
          aplCodeLabel: 'APL Code / Description',
          aplCodePlaceHolder: 'Enter Code or Description',
          locationLabel: 'Location',
          locationPlaceHolder: 'Select Location',
        },
        content: {
          refineSearch: 'Please refine search to populate results',
          pluCode: 'Product Code',
          productName: 'Product Name',
          category: 'Category',
          subCategory: 'Sub-Category',
          excludedLocations: 'Excluded Locations',
          excludedChip: 'Excluded',
          productsSelected: 'products selected',
          selected: 'selected',
          editProductExclusionTitle: 'Edit Product Exclusion',
          newProductExclusionTitle: 'New Product Exclusion',
          noRecordsFound: 'No Records to View',
        },
      },
    },
    helper: {
      selectedCount: '{{count}} selected',
      selectedNamedCount: '{{count}} {{name}} selected',
    },
    tooltip: {
      sourceOfPrice: `The source of the price for sale\non-receipt-return when POS is offline from the pharmacy system.`,
    },
  },
  BasicDefinitions: {
    barcodeRequired: {
      label: 'Barcode Required',
      on: 'YES',
      off: 'NO',
    },
    title: 'Basic Definitions',
    openDrawerLabel: 'Open Drawer...',
    openDrawer: {
      AlwaysOpen: 'Always',
      OpenOnSaleOnly: 'When received tender',
      OpenOnRefundOnly: 'When returning this tender',
      DoNotOpen: 'Never',
    },
    isBottleDepositVoucher: {
      label: 'Bottle deposit voucher',
      on: 'YES',
      off: 'NO',
    },
    blockPartialPayment: {
      label: 'Block Partial Payment',
      on: 'YES',
      off: 'NO',
    },
    paymentPriority: {
      label: 'Payment Priority',
      placeholder: 'Enter a Payment Priority',
    },
    requestForTendering: {
      label: 'Request for tendering',
      on: 'YES',
      off: 'NO',
      tooltip:
        'If set to “No” then on adding a voucher in sale mode the POS will not move to tendering',
    },
    customerProgramType: {
      label: 'Customer Program Type',
      placeholder: 'Select a Customer Program Type',
      incomm: 'InComm'
    },
  },
  ChangeDefinition: {
    columns: {
      tender: 'Tender',
      upToAmount: 'Up to Amount',
      edit: 'Edit',
      delete: 'Delete',
    },
    placeholder: {
      enterUpToAmount: 'Enter Up to Amount',
      selectATender: 'Select Tender',
    },
    error: {
      duplicateTender: 'Duplicate Tender',
    },
  },
  ImmediateTenderingOptions: {
    panelTitle: 'Immediate Tendering Options',
    tenderAmountLabel: 'Tender amount required',
    tenderAmountOptions: {
      YesWithoutDefault: 'Open Amount',
      YesWithDefault: 'Open Amount, Balance Due as Default',
      YesWithSuggestedAmounts: 'Open Amount with Suggested Options',
      No: 'Immediate Closing, Balance Due as Default',
    },
  },
  TenderAmountOptions: {
    columns: {
      roundTo: 'Round To',
      posDisplay: 'POS Display',
      value: 'Value',
      edit: 'Edit',
      delete: 'Delete',
    },
    roundTo: {
      manual: 'Manual',
      exact: 'Exact amount',
      nearest: 'Round to nearest',
    },
    posDisplay: {
      onDisplay: 'On Display',
      scroll: 'Scrollable',
    },
    requiredField: 'This field is required.',
  },
  TenderAuthorization: {
    panelTitle: 'Tender Authorization',
    authorizationMethodLabel: 'Authorization Method',
    authorizationMethodOptions: {
      None: 'None',
      ProcessWithEPS: 'Process with EPS',
    },
    tagsFieldLabel: 'Tender EPS Reference',
    tagsFieldPlaceholder: 'Type and press ENTER to add...',
  },
  TenderRewardMapping: {
    panelTitle: 'Specific Definition',
    defaultRewardTender: {
      label: 'Default Reward Tender',
      on: 'YES',
      off: 'NO',
    },
    rewardTypeMapping: 'Reward Type Mapping',
    rewardTypeMappingPlaceholder: 'Type and press ENTER to add...',
  },
  ProhibitActionDefinitions: {
    panelTitle: 'Prohibit Action Definitions',
    ProhibitOverTender: {
      label: 'Prohibit Over Tender',
      on: 'YES',
      off: 'NO',
    },
    ProhibitPayment: {
      label: 'Prohibit Payment',
      on: 'YES',
      off: 'NO',
    },
    ProhibitRefund: {
      label: 'Prohibit Refund',
      on: 'YES',
      off: 'NO',
    },
    ProhibitVoid: {
      label: 'Prohibit Void',
      on: 'YES',
      off: 'NO',
    },
    tooltipContent: {
      new: 'Eligible for exception.',
      existing: 'Exception has been created.',
      buttonNew: 'Create Exception',
      buttonExisting: 'View Exception',
    },
    errors: {
      messageId: 'Message is required',
    },
  },
  ConsolidateOnChange: {
    label: 'Consolidate On Change',
    yes: 'YES',
    no: 'NO',
  },
  DisableAutomaticVoid: {
    label: 'Disable Automatic Void',
    yes: 'YES',
    no: 'NO',
    tooltip:
      'Allows disabling the automatic void of the paid tenders in case of change. For example, customer buys items worth $120. The customer pays with vouchers in the following order: $10, $50 and $70. Change due is $10. If set to No, the $10 voucher is voided. If set to Yes, the $10 change is issued according to change definitions.',
  },
  CheckValidator: {
    label: 'MICR Validator',
    placeholder: 'Select Check Validator',
  },
  MessagePicker: {
    label: 'Message',
    placeholder: {
      enterMessageName: 'Enter Message Name',
      enterMessageTitle: 'Enter Message Title',
      enterMessageBodyOrInstruction: 'Enter Message Body or Instruction',
    },
    buttons: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      addLanguage: '+ Add Language',
      deleteLang: 'Delete Language',
      edit: 'Edit',
      view: 'View',
    },
    dialog: {
      createNewLabel: 'Create New Message',
      editMessage: 'Edit Message',
      viewMessage: 'View Message',
      descriptionNewLine:
        'Enter the information below to create a new message that will be displayed on the POS when this (insert name of type)',
      descriptionEditLine:
        'Enter the information below to edit a message that will be displayed on the POS when this (insert name of type)',
      descriptionViewLine:
        'The information below is the message that will be displayed on the POS when this (insert name of type)',
      description2line: 'action is triggered. See the POS message example for context.',
      addContent: 'Add Content',
      lang: 'Language',
      messageName: 'Message Name',
      title: 'Title',
      instruction: 'Message Body or Instructions',
    },
    validation: {
      language: 'Language is Required',
      name: 'Name is Required',
      titleBody: 'You must enter a Title or Message',
    },
    notifications: {
      delete: 'Message Has Been Deleted',
      save: 'Message Has Been Saved',
      update: 'Message Has Been Updated',
    },
  },
  TenderGroup: {
    dialog: {
      editTenderGroup: 'Edit Tender Group',
      newTenderGroup: 'New Tender Group',
    },
    notifications: {
      delete: 'Tender Group Has Been Deleted',
      save: 'Tender Group Has Been Saved',
      update: 'Tender Group Has Been Updated',
    },
    label: {
      location: 'Location',
    },
    placeholder: {
      enterName: 'Enter Name',
      enterDescription: 'Enter Description',
      selectLocation: 'Select Location',
    },
    validation: {
      name: 'Name is Required',
    },
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    droppableArea: 'Drag Tenders here to create your Tender Group',
    no_tenders: 'There are currently no Tenders in the system.',
    no_results: 'No Results Found.',
    warning: 'The following tenders have been voided and removed: \n',
  },
  ExcludedDates: {
    endsOn: 'Ends on {{date}} {{time}}',
    columns: {
      ignore: 'Ignore',
      nextDay: 'Next Day',
      time: 'End Time',
      date: 'Business Date',
      isReoccurringDate: 'Recurring',
    },
    fields: {
      businessDate: {
        label: 'Business Date',
        placeholder: 'Filter by date greater than',
      },
      date: {
        label: 'Business Date',
        placeholder: 'Enter Business Date',
      },
      time: {
        label: 'End Time',
      },
      activeOnly: 'Show Active Only',
    },
    errors: {
      duplicatedDate: 'Duplicated date',
      timeRequired: 'Time is a required field'
    }

  },
  EditableTable: {
    emptyTable: 'Enter fields above to populate the table',
  }
};
